import React, { useEffect, useState, Fragment } from "react";
import { Field } from "formik";
import styled from "styled-components"
import CloseIcon from "@material-ui/icons/Close";

const MultipleFileInputPTPLUS = ({props, name, fileArr, acceptFiles, callBack, errorMsg,forwardedRef, btnTxt, mandatory, clickHandler}) => {
  const [fileState, updateFileState] = useState({
    files: '0',
    filesArr: []
  });

  useEffect(() => {
    if (fileState.filesArr.length !== 0) {
      callBack(fileState.filesArr)
    }
  });

  const attachFiles = (form, meta) => {
    return <label className="uploadPhoto" htmlFor="file">
      {fileState.filesArr.length !== 0 && (
        fileState.filesArr.map((file, index) => (
          <div key={index}>
            <span>{file.name}</span>
            <CloseIcon onClick={() => {
              let filterData = fileState.filesArr.filter((item, i) => i !== index)
              fileArr.splice(index, index)
              form.setFieldValue(name, filterData);

              fileState.filesArr.splice(index, index)
              updateFileState({ ...fileState, filesArr: filterData });
              if (fileState.filesArr.length === 1) {
                callBack([])
              } else {
                callBack(fileState.filesArr)
              }
            }} />
          </div>
        ))
      )}
      {meta.error && <p name={name + 'Error'} className="error-message-multiple">{meta.error}</p>}
    </label>
  }

  const handleChange = async (name, e, setFieldValue, setFieldError) => {
    e.preventDefault();
    const fileTypes = acceptFiles.split(',');
    let files = e.target.files;
    //eslint-disable-next-line
    var specialChar = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
    for (let i = 0; i < files.length; i++) {
      let file = files[i];
      let uploadFileName = file?.name
      let uploadFileNameFirstString = uploadFileName?.substring(0, 1)
      if (uploadFileNameFirstString && specialChar.test(uploadFileNameFirstString)) {
        setFieldError(name, "Please upload an image with valid name.");
        return false;
      } else if (file && fileTypes.includes(file.type)) {
        if (file.size > 5242880) {
          setFieldError(name, "Please upload a file smaller than 5MB.");
          return false;
        } else {
          fileArr.push(file)
          for (let i = 0; i < fileState.filesArr.length; i++) {
            if (fileState.filesArr[i].name === file.name) {
              setFieldError(name, "File already attached.");
              return false;
            }
          } if (fileState.filesArr.length <= 2) {
            updateFileState({
              ...fileState, filesArr: [...fileState.filesArr, file]
            })
          }

        }
        setFieldValue(name, null)
      } else {
        setFieldError(name, errorMsg);
        clickHandler(null);
      }
    }
  };

  return (
    <>
      <Field name={name}>
        {({ form, meta }) => (
          <Fragment>
            <InputWrapper className='multiple-file-input'>
              <input
                id={name}
                ref={forwardedRef}
                type="file"
                className="custom-file-input1"
                accept={acceptFiles}
                multiple={false}
                onClick={e => (e.target.value = '')}
                onChange={e =>
                  handleChange(name, e, form.setFieldValue, form.setFieldError)
                }
                aria-label="file"
              />
              <span className='text'>
                {btnTxt}
                {mandatory === "Star" && <span className="star">*</span>}

              </span>

              {attachFiles(form, meta)}
            </InputWrapper>
          </Fragment>
        )}
      </Field>
    </>
  );
};

export default MultipleFileInputPTPLUS;
const InputWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  .text {
    border-radius: 4px;
    padding: 9px 32px;
    font-family: 'latomedium';
    border-radius: 5px;
    position: absolute;
    left: auto;
    top: 0;
    font-size: 16px;
    cursor: pointer;
    /* background: linear-gradient(90deg, #55C416 0%, #367910 100%); */
    /* background: #005586b3; */
    background: rgb(0,85,134);
    color: white;
  }
  .custom-file-input1 {
    opacity: 0;
    max-width: 213px;
    cursor: pointer;
    height: 42px;
    z-index: 1 !important;
    margin-bottom: 18px;
  }
`;